import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react"

export const apiSlice = createApi({
    reducerPath:"api",
    baseQuery: fetchBaseQuery({
        "baseUrl": "http://127.0.0.1:8080/"
    }),
    endpoints:(builder) => ({
        verifyProfile: builder.mutation({
            query:(verify_data) => ({
                url: "/user",
                method: "POST",
                body: verify_data
            })
        }),
        submitProfile: builder.mutation({
            query:(submit_data) => ({
                url: "/user/create_profile/",
                method: "POST",
                body: submit_data
            })
        })
    })
})

export const {useVerifyProfileMutation, useSubmitProfileMutation} = apiSlice

